<nb-layout>
  <nb-layout-header class="page-header" fixed>
    <div class="header-content">
      <div class="header-left">
        <img src="assets/wisee-logo.svg" alt="Wisee" class="header-logo" (click)="goToDashboard()">
        <div class="admin-nav" *ngIf="isAdmin">
          <button nbButton size="small"
                  *ngFor="let link of adminLinks"
                  [appearance]="isLinkActive(link.route) ? 'filled' : 'ghost'"
                  [status]="isLinkActive(link.route) ? 'primary' : 'basic'"
                  (click)="goToAdminRoute(link.route)"
                  [class.active]="isLinkActive(link.route)">
            <nb-icon [icon]="link.icon"></nb-icon>
            <span>{{ link.label }}</span>
          </button>
        </div>
      </div>
      <div class="header-right">
        <button nbButton size="small" status="basic" class="logout-button" (click)="logoutAction()">
          <nb-icon icon="log-out-outline"></nb-icon>
          Déconnexion
        </button>
      </div>
    </div>
  </nb-layout-header>

  <nb-layout-column class="main-content">
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>
